export const ImageStyles = {
  borderRadius: "15px",
};
